export default __webpack_public_path__ + "static/media/Group 332.215800bd.png";